import { ScheduleManagementPage } from "../../../components/schedule/ScheduleManagementPage";

export function CoachSchedulePage() {
  return <ScheduleManagementPage role="coach" />;
}
